export const environment = {
  production: false,
  envName: 'staging',
  baseFixUrl: 'https://marketing-qa.fixdigitalcrm.com/',
  baseUrl: 'https://marketing-qa.fixdigitalcrm.com/api/crm/webapp/v1/',
  baseUrlV1: "https://marketing-qa.fixdigitalcrm.com/api/crm/webapp/v1/",
  baseUrlV2: "https://marketing-qa.fixdigitalcrm.com/api/crm/webapp/v2/",
  version: "2.4.87"
};
